import React from 'react';
import SectionHeader from '../SectionHeader';
import BCPFieldRenderer from './BCPFieldRenderer';
import type { BCPSectionConfig } from '../../config/bcpFieldConfig';

interface BCPSectionCardProps {
  section: BCPSectionConfig;
  values: Record<string, string>;
  errors?: Record<string, string>;
  onChange: (fieldId: string, value: string) => void;
  onAIConsult?: (fieldId: string) => void;
}

const BCPSectionCard: React.FC<BCPSectionCardProps> = ({ section, values, errors, onChange, onAIConsult }) => {
  const handleChange = (fieldId: string, value: string) => {
    console.log('[BCPSectionCard] onChange called:', { fieldId, valueLength: value?.length || 0 });
    onChange(fieldId, value);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <div className="p-6">
        <SectionHeader title={section.displayTitle ?? section.title} />

        <div>
          {section.fields.map((field) => (
            <BCPFieldRenderer
              key={field.id}
              field={field}
              values={values}
              errors={errors}
              onChange={handleChange}
              onAIConsult={onAIConsult}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BCPSectionCard;
